export default __webpack_public_path__ + "static/media/welcome-illustration.4a259212.png";